import * as React from 'react';
import { Link } from 'react-router-dom';
import Paths from '../../models/enums/paths';
import * as styles from './segments.module.scss';
import { withRouter, RouteComponentProps } from 'react-router';

interface Props {
  segmentId: string;
}

const SegmentMenu = ({ segmentId, location }: Props & RouteComponentProps) => {
  return (
    <div>
      <ul className={styles.menu}>
        <Link
          to={Paths.Segment.replace(':segmentId', segmentId)}
          className={location.pathname.endsWith(segmentId) ? styles.current : undefined}
        >
          <li className={styles.menuItem}>Query</li>
        </Link>
        <Link
          to={Paths.SegmentPushes.replace(':segmentId', segmentId)}
          className={location.pathname.endsWith('pushes') ? styles.current : undefined}
        >
          <li className={styles.menuItem}>Pushes</li>
        </Link>
        <Link
          to={Paths.SegmantDependencies.replace(':segmentId', segmentId)}
          className={location.pathname.endsWith('dependencies') ? styles.current : undefined}
        >
          <li className={styles.menuItem}>Dependencies</li>
        </Link>
      </ul>
    </div>
  );
};

export default withRouter(SegmentMenu);
